import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full bg-gray-lp-1000",
  "data-testid": "handover-list-page"
}
const _hoisted_2 = {
  class: "py-2 px-5 flex flex-row justify-between items-center bg-white",
  "data-testid": "handover-list-header"
}
const _hoisted_3 = { class: "font-semibold self-center text-20px whitespace-no-wrap text-black-lp-200" }
const _hoisted_4 = { class: "p-3 bg-gray-lp-1000" }
const _hoisted_5 = { class: "bg-white rounded-xl border border-gray-lp-400 p-4 flex flex-col flex-1 overflow-hidden" }
const _hoisted_6 = { class: "flex flex-row items-center gap-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_VendorStatusFailedModal = _resolveComponent("VendorStatusFailedModal")!
  const _component_EligibilityFailedModal = _resolveComponent("EligibilityFailedModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1),
      (_ctx.ableToCreate)
        ? (_openBlock(), _createBlock(_component_lp_button, {
            key: 0,
            title: _ctx.$t('handover.list.update'),
            textColor: "white",
            color: "red-lp-2400",
            "data-testid": "handover-list-update",
            onClick: _ctx.goToUpdate
          }, null, 8, ["title", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            class: "w-72",
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.searchValue,
            minChar: 1,
            timeout: 1000,
            placeholder: _ctx.$t('handover.list.searchId'),
            "data-testid": "handover-list-search",
            isIconLeft: "",
            isIconClearRight: "",
            colorIcon: "#4D4D4D"
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode(_component_Select, {
            dataSelect: _ctx.subConsoleList,
            onChooseSelect: _ctx.onSelectSubConsole,
            onOpenSelect: _ctx.onOpenSelectSubConsole,
            onCloseSelect: _ctx.onCloseSelectSubConsole,
            isOpenMenu: _ctx.isOpenSelectSubConsole,
            value: _ctx.destinationPartnerId,
            placeholder: _ctx.$t('handover.list.searchSubConsole'),
            class: "w-64",
            "data-testid": "handover-list-select-subconsole",
            isDefaultBlack: ""
          }, null, 8, ["dataSelect", "onChooseSelect", "onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "placeholder"]),
          _createVNode(_component_time_range_picker, {
            default: _ctx.$t('30 hari terakhir'),
            startDate: _ctx.startDate,
            endDate: _ctx.endDate,
            "data-testid": "handover-list-select-date",
            onSelect: _ctx.setDateRange,
            customBackground: "bg-white",
            customIcon: "calendar-outlined"
          }, null, 8, ["default", "startDate", "endDate", "onSelect"])
        ]),
        _createVNode(_component_TableV2, {
          columns: _ctx.columns,
          data: _ctx.handoverList,
          loading: _ctx.isLoading,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          paginationStyle: "v3",
          paginationV3PaddingVertical: "py-2",
          customClassPagination: 
            'absolute w-full bottom-4  right-0 left-0 px-8'
          ,
          pinnedSubstractHeight: "242px",
          marginPaginationVertical: false,
          isPinnedScrollBottom: "",
          isSpaceTop: false,
          isNoPaddingBottom: "",
          totalColumnFreeze: 1,
          isRightFreeze: true,
          onRequest: _ctx.fetchHandoverList,
          isDetailAble: _ctx.ableToDetail,
          onClick: _ctx.onClickRow,
          errorCause: _ctx.errorCause,
          borderTop: false,
          onTryAgain: _ctx.fetchHandoverList,
          "data-testid": "handover-list-table",
          bgHeader: "bg-white border-b border-t border-gray-lp-200"
        }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "isDetailAble", "onClick", "errorCause", "onTryAgain"])
      ])
    ]),
    (_ctx.showFailedVendorModal)
      ? (_openBlock(), _createBlock(_component_VendorStatusFailedModal, {
          key: 0,
          handoverId: _ctx.selectedHandoverId,
          eligibleRetry: _ctx.eligibleRetryVendorStatus,
          onClose: _ctx.closeFailedVendorModal,
          onRetry: _ctx.onClickRetry
        }, null, 8, ["handoverId", "eligibleRetry", "onClose", "onRetry"]))
      : _createCommentVNode("", true),
    (_ctx.showEligibilityModal)
      ? (_openBlock(), _createBlock(_component_EligibilityFailedModal, {
          key: 1,
          handoverId: _ctx.selectedEligibilityHandoverId,
          onClose: _ctx.closeEligibilityModal
        }, null, 8, ["handoverId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showRetryProcess)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onSubmit: _ctx.closeRetryProcess,
          onClose: _ctx.closeRetryProcess,
          title: _ctx.$t('handover.list.retry.processTitle'),
          message: _ctx.$t('handover.list.retry.processBody', { n: _ctx.retryProcessCount }),
          image: "print-label-pending",
          textSuccess: _ctx.$t('handover.list.retry.processOk'),
          class: "px-8",
          "data-testid": "handover-list-retry-process-modal",
          color: "red-lp-2400"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess"]))
      : _createCommentVNode("", true)
  ]))
}